import Cookies from "cookies-js";

class UnbounceClient {
  static trackConversion = () => {
    // delete unbounce cookie that excludes pages
    Cookies.expire("ubpv", { path: window.location.pathname });
    /* eslint-disable */
    // code copied from here
    // https://documentation.unbounce.com/hc/en-us/articles/203879180-Setting-Conversion-Goals#content2
    window._ubaq = window._ubaq || [];
    window._ubaq.push(["trackGoal", "convert"]);
    var ub_script = document.createElement("script");
    ub_script.type = "text/javascript";
    ub_script.src =
      ("https:" == document.location.protocol ? "https://" : "http://") +
      "d3pkntwtp2ukl5.cloudfront.net/uba.js";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(ub_script, s);
    /* eslint-enable */
  };
}

export default UnbounceClient;
